<template>
  <div class="indicator">
    <div class="title">
      {{title}}
    </div>
    <div class="body">
      <div class="qty">
        <slot v-if="$slots.qty" name="qty"></slot>
        <template v-else>
          {{ amount}} {{currency}}
        </template>
      </div>
      <div class="footer">
        <div class="detail">
           {{detail}}
        </div>
        <div 
            class="growth-indicator"
            :class="{
              'is-growth': isGrowth
            }"
          >
          <div 
            class="icon"
            >
            <IconChartlineVariant 
              :size="24"
            />
          </div>
          <div class="value">
            {{_growth}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup >
 import IconChartlineVariant from "@/components/icons/IconChartlineVariant.vue" 
 import { computed } from 'vue' 
 const props = defineProps({
  amount: {
    type: String,
    default: 0
  },
  title: {
    type: String,
    default: ''
  },
  currency: {
    type: String,
    default: 'USD'
  },
  detail: {
    type: String,
    default: ''
  },
  growth_value: {
    type: String,
    default: ''
  },
  isGrowth: {
    type: Boolean,
    default: false
  },
  growthIsView: {
    type: Boolean,
    default: true
  },
 })
 const _growth = computed(() => {
   return parseFloat(props.growth_value).toFixed(2)
 })

</script>

<style lang="scss" scope >
  .indicator {
    border: 1px solid rgba(151, 151, 151, 30%);
    background: #fff;
    border-radius: 10px;
    padding: 14px;
    .title {
      font-size: 14px;
    }
    .body {
      margin: 32px 0 0 0;
      display: flex;
      flex-direction: column;
      gap: 4px;
      .qty {
        font-size: 16px;
        font-weight: 900;
      }
      .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        .growth-indicator {
          display: grid;
          grid-template-columns: 30px 1fr;
          align-items: center;
          gap: 4px;
          color: #F93C65;
          .icon{
            display: flex;
            align-items: center;
            svg {
                transform: scaleY(-1);
                display: block
            }

          }
          &.is-growth {
            .value {
              font-weight: 600;
            }
            color: #00B69B;
            svg {
                transform: scaleY(1);
            }
          }
        }
      }
    }
  }
</style>
 